<template>
  <!-- 일정 변경 -->
  <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      content-class="bottom-sheet travel-sheet"
  >
    <v-card>
      <SheetHeader :title="'일정'" @sheetClose="closeSheet"/>
      <v-card-text class="sheet-body pos-relative">
        <div class="slider mb-3">
          <Flicking ref="flick" :options="{ bound: true, align: 'prev', defaultIndex: (selected)}">
            <div v-for="(item, index) in resultList"
                 :key="index"
                 class="day"
                 :class="{'select': selected === index}"
                 @click="openSheet(index)"
            >{{ index + 1 }}
            </div>
          </Flicking>
        </div>
        <div>
          <!-- <div class="d-flex align-center black--text py-3 mb-3"><span class="fs-24 fw-700 mr-2">01</span> <span class="fs-14">21/11/01(월)</span></div> -->
          <div class="d-flex align-center black--text py-3 mb-3"><span
              class="fs-24 fw-700 mr-2">{{ selected + 1 }}</span> <span class="fs-14"></span></div>
          <ul class="mission-list">
            <li class="mb-4" v-for="n in unitList.length" :key="n"
                @click="unitDetail(unitList[n-1].unitUseNo, unitList[n-1].freeYn, n, current, unitList[n-1].cmpltYn, selected, unitList[n-1].unitType, unitList[n-1].cmpltDt)">
              <div class="d-flex flex-column">
                <span class="fs-12 lightGray--text tracking-tighter">{{ unitList[n - 1].unitTypeNm }}<span
                    v-if="unitList[n-1].unitTypeCnt-1 > 0">+{{ unitList[n - 1].unitTypeCnt - 1 }}</span></span>
                <span class="fs-16 black--text">{{ unitList[n - 1].unitNm }}</span>
              </div>
              <v-checkbox
                  v-model="unitList[n-1].cmpltYn"
                  :ripple="false"
                  class="checkbox-circle size-lg m-0"
                  hide-details
                  readonly
              ></v-checkbox>
            </li>
          </ul>
        </div>
        <v-overlay absolute :value="isLoading">
          <v-progress-circular
              indeterminate
              size="24"
          />
        </v-overlay>
      </v-card-text>
    </v-card>
  </v-bottom-sheet>
</template>
<script>
import store from '@/store'
import {mixinRemote, mixinTrial} from "@/mixins";
import SheetHeader from './SheetHeader'

export default {
  components: {
    SheetHeader
  },
  mixins: [mixinRemote, mixinTrial],
  props: ['useStatus', 'weekday', 'resultList', 'progYn', 'ordDtlNo'],
  data: () => ({
    sheet: false,
    list: [],
    days: 0,
    //  select: 0,
    //  sheet: false,
    defaultIndex: 0,
    unitMappingInfo: [],
    unitList: [],
    current: 1,
    isLoading: false,
    selected: 0
  }),
  computed: {
    day () {
      return this.resultList.length
    }
  },
  watch: {
  },
  created () {
  },
  mounted() {
  },
  methods: {
    openSheet (selected = this.weekday - 1, list = this.resultList) {
      if (this.isTrialDayExceeded(selected)) {
        this.$alert(this.trialResumeAlertMessage)
        return
      }
      // weekday 는 1부터
      // selected 는 0부터
      this.selected = selected
      if ((this.weekday < selected + 1) && this.progYn === 'Y') {
        if (this.useStatus == '01') {
          this.$alert('어떤 여행이 기다리고 있을까요?<br/>기대해 주세요:)').then(result => {
            if (result && this.selected !== this.weekday - 1) {
              this.selected = this.weekday - 1
              this.openSheet()
            }
          })
        } else {
          this.$alert(`티켓 이용이 중지되었어요.<br/>(중지기간 ${this.useOrdDtl.useStopStartDtSt} ~ ${this.useOrdDtl.useStopEndDtSt})`)
              .then(() => {
                if (this.selected !== this.weekday - 1) {
                  this.selected = this.weekday - 1
                  this.openSheet()
                }
              })
        }
        return false
      }
      this.sheet = true
      this.getSolutionUnitList(list)
    },
    closeSheet () {
      this.sheet = false
      this.$router.replace({ path: `${this.$route.path}`, query: {}}).catch(()=>{})
    },
    async getSolutionUnitList(list) {
      let scheduleList = (list) ? list : this.resultList
      if (scheduleList.length === 0) return false
      let select = this.selected
      let params = [
        {'sltUseNo': scheduleList[select].sltUseNo},
        {'week': scheduleList[select].week},
        {'day': scheduleList[select].day},
        {'ordDtlNo': this.ordDtlNo}
      ]
      this.isLoading = true
      await store.dispatch('getSolutionUnitList', this.$_payload('so', params))
          .then(res => {
            if (res.success) {
              res.data.forEach((element, index) => {
                // 카테고리 노출 여부
                if (element.unitType == '12' || element.unitType == '13' || element.unitType == '14'
                    || element.unitType == '15' || element.unitType == '16') {
                  element.unitTypeNm = ''
                }

                // 완료 여부 및 진행 current 값 수정
                if (element.cmpltYn == 'Y') {
                  element.cmpltYn = true
                  this.current = index + 2
                } else {
                  element.cmpltYn = false
                  // 지난회차일때 미완료 이더라도 마음날씨 마음노트 current 증가 시켜서 다음 유닛 시행가능
                  if ((select < this.weekday) && (element.unitType == '15' || element.unitType == '12')) {
                    this.current = index + 2
                  }
                }
              });
              this.unitList = res.data

              let moveTo = 0;
              if (select > 3) {
                moveTo = select - 3
              }
              setTimeout(() => this.$refs.flick.moveTo(moveTo), 100);

            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
            this.isLoading = false
            this.$router.replace({ query: { selected: this.selected }}).catch(()=>{})
          })
    },
    unitDetail: function (unitUseNo, freeYn, key, current, cmpltYn, select, unitType, regDt) {

      const isFree = store.state.remote.solutions.some(item => {
              if (item.freeYn === "Y" && item.unitUseNo == unitUseNo) return true
            })
      freeYn = isFree?"Y":"N"

      // if (this.useStatus == '02') {
      //   this.$alert(`티켓 중지중 입니다.`)
      //   return false
      // }

      if (this.progYn == 'N') {
        // 과거 여행지의 경우 상세 호출시 완료로 간주
        if (cmpltYn) {
          this.$router.push({name: '솔루션', query: {'unitUseNo': unitUseNo, 'freeYn': freeYn, 'cmpltYn': cmpltYn, 'progYn': this.progYn, 'beforeOrdDtlNo': this.ordDtlNo}})
        } else {
          this.$alert(`과거 여행지 미션은 재 수행이<br/> 불가합니다.`)
        }
      } else if (this.progYn == 'Y') {

        if (select + 1 < this.weekday && !cmpltYn && (unitType == '15' || unitType == '12')) {
          this.$alert(`지난 회차의 마음날씨, 마음노트는<br />작성이 불가합니다.<br />마음노트 다음 미션부터<br />순서대로 진행해 주세요.`)
        } else if (key > current || this.weekday < select) {  //
          this.$alert('미션을 순서대로 진행해주세요:)')
        } else { // 완료일때
          // this.$router.push({name: '솔루션', params: {'unitUseNo': unitUseNo, 'freeYn': freeYn, 'cmpltYn':cmpltYn}})

          if (select + 1 < this.weekday){// 과거유닛 진입시
            this.$router.push({name: '솔루션', query: {unitUseNo, freeYn, cmpltYn, 'pastYn': 'Y', regDt}})
          } else {
            this.$router.push({name: '솔루션', query: {unitUseNo, freeYn, cmpltYn, regDt}})
          }
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-dialog {
  .sheet-body {
    padding-top: 28px;

    .flicking-viewport {
      .day {
        position: relative;
        padding: 0 18px;
        font-size: 16px;
        padding-bottom: 16px;
        line-height: 1;
        font-weight: 500;
        color: $color-gray-1;

        &.select {
          color: $color-main;

          &:after {
            position: absolute;
            content: '';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: $color-main;
            bottom: 0px;
            left: 50%;
            transform: translateX(-50%);
          }
        }

      }
    }

    .mission-list {
      padding-left: 37px;

      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #F2F2F2;
        border-radius: 4px;
        height: 80px;
        padding: 0 20px;
      }
    }
  }

}
</style>
